import React, { useState } from "react"
import showFloatToPercentage from "../../V2Leaderboard/Utils/showFloatToPercentage"


const SilhouetteShare = ({ silhouetteShare, heading, icon, tag, setImagePopupData, trend }) => {
  const [showSilhouetteBreakdown, setSilhouetteBreakdown] = useState(false)

  return silhouetteShare ? <div className="text-wrap flex mx-1">
    <img src={icon} alt="" className="h-4 mr-1 inline-block " />
    <p>
      <span className="font-semibold">{heading} </span> {(showSilhouetteBreakdown ? silhouetteShare : silhouetteShare.slice(0, 4)).map((s, index) => (<React.Fragment key={index}>
        {index != 0 ? <span>, </span> : null}
        <button onClick={setImagePopupData} id={`${trend.category}__${trend.tag}__${trend.value}__${tag || 'silhouette'}__${s.value}`}>{`${s.value} ${Math.round(showFloatToPercentage(s.share, 1))}% `}</button>
      </React.Fragment>))}{silhouetteShare.length > 4 ? <button
        className="font-semibold hover:font-bold ml-4"
        onClick={(e) => {
          e.stopPropagation()
          setSilhouetteBreakdown(prev => (!prev))
        }}>{showSilhouetteBreakdown ? "   show less" : "   and more..."}</button> : null}
    </p>
  </div> : null
}

export default SilhouetteShare
